import { Space } from "antd";
import { useState } from "react";
import OptSingleInput from "./components/OtpSingleInput";

const NUM_OF_INPUTS = 8;

interface Props {
    inputs: string[];
    setInputs: React.Dispatch<React.SetStateAction<string[]>>;
}

const OtpInput = ({ inputs, setInputs }: Props) => {
    const [currentFocus, setCurrentFocus] = useState<number>(0);

    const setInput = (index: number, value: string) => {
        const newInputs = [...inputs];
        if (value === "") {
            newInputs[index] = "";
            if (index > 0) {
                setCurrentFocus(index - 1);
            }
        } else if (value >= "0" && value <= "9") {
            newInputs[index] = value;
            if (index < NUM_OF_INPUTS - 1) {
                setCurrentFocus(index + 1);
            }
        }

        setInputs(newInputs);
    }

    const onOtpPaste = (value: string) => {
        let newInputs = Array(NUM_OF_INPUTS).fill("");
        let length = value.length < NUM_OF_INPUTS ? value.length : NUM_OF_INPUTS;
        for (let i = 0; i < length; i++) {
            newInputs[i] = value[i];
        }
        setInputs(newInputs);
    }

    return (
        <Space size={16}>
            {[...Array(NUM_OF_INPUTS)].map((_, index) => {
                return (
                    <OptSingleInput
                        key={index}
                        index={index}
                        setInput={setInput}
                        value={inputs[index]}
                        currentFocus={currentFocus}
                        setCurrentFocus={setCurrentFocus}
                        onOtpPaste={onOtpPaste} />
                )
            })}
        </Space>
    )
}

export default OtpInput;